<template>
    <div class="contact">
            <!-- Contact Section -->
    <section id="contact" class="contact section">

      <!-- Section Title -->
      <div class="container section-title" data-aos="fade-up">
        <h2>{{title}}</h2>
      </div><!-- End Section Title -->


      <div class="container" data-aos="fade-up" data-aos-delay="100">

        <div class="row gy-4">
          <div class="col-lg-12 ">
            <div class="row gy-4">

              <div class="mb-5" data-aos="fade-up" data-aos-delay="200">
                <iframe style="border:0; width: 100%; height: 370px;" class="rounded-3 shadow" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d33634.888805580624!2d106.86846372665254!3d-6.298481643018746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69ed75a91d7fc9%3A0xa9daae458cb1104a!2sPT%20Fastana%20Logistik%20Indonesia!5e0!3m2!1sen!2sid!4v1729041255956!5m2!1sen!2sid" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div><!-- End Google Maps -->

              <div class="col-lg-12">
                <div class="info-item d-flex flex-column justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="200">
                  <i class="bi bi-geo-alt"></i>
                  <h3>Alamat</h3>
                  <a href="https://maps.app.goo.gl/jHCRu91tSLqLoY6d8" target="_blank">
                      <p style="color: black;">{{ address }}</p>
                  </a>
                </div>
              </div><!-- End Info Item -->

              <div class="col-md-6">
                <div class="info-item d-flex flex-column justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="300">
                  <i class="bi bi-telephone"></i>
                  <h3>Telepon</h3>
                  <a href="tel:+622122826259" style="color: black;">+62-21-2282-6259</a>
                </div>
              </div><!-- End Info Item -->

              <div class="col-md-6">
                <div class="info-item d-flex flex-column justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="400">
                  <i class="bi bi-envelope"></i>
                  <h3>Email</h3>
                  <a href="mailto:hello@fli.co.id" target="_blank">
                      <p style="color: black;">hello@fli.co.id</p>
                  </a>
                </div>
              </div><!-- End Info Item -->

            </div>
          </div>
        </div>

      </div>

    </section><!-- /Contact Section -->
    </div>
</template>

<script>
import ContactJs from './js/app.js';
export default ContactJs;
</script>